import React, { useState } from "react";

// =============================================================
// RequestDeleteModal — submits a triple-admin deletion request
// with a required reason. Replaces prompt() usage.
// =============================================================
export default function RequestDeleteModal({ node, onConfirm, onClose, submitting }) {
  const [reason, setReason] = useState("");
  const canConfirm = !!reason.trim() && !submitting;

  return (
    <div className="modal-overlay" data-testid="del-req-modal" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Request Deletion — {node.slotRef}</div>
          <button className="modal-close" onClick={onClose} data-testid="del-req-close" aria-label="Close">×</button>
        </div>
        <div className="modal-body">
          <div style={{ padding: 12, background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.30)", borderRadius: 10, marginBottom: 14, fontSize: 12, color: "#f59e0b", fontFamily: "'Montserrat',sans-serif", lineHeight: 1.55 }}>
            Deletion is permanent and requires <strong>3 admin approvals</strong>. The request expires after 30 days.
          </div>
          <label style={{ fontSize: 11, color: "var(--kc-sub)", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700 }}>Reason (required)</label>
          <textarea
            data-testid="del-req-reason"
            autoFocus
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Explain why this record should be permanently deleted…"
            className="form-input"
            style={{ width: "100%", marginTop: 6, minHeight: 100 }}
          />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline btn-sm" onClick={onClose} data-testid="del-req-cancel">Cancel</button>
          <button
            type="button"
            data-testid="del-req-submit"
            disabled={!canConfirm}
            onClick={() => onConfirm(reason.trim())}
            className="btn btn-sm"
            style={{
              background: canConfirm ? "#ff6b6b" : "rgba(255,107,107,0.30)",
              color: canConfirm ? "var(--kc-on-accent)" : "var(--kc-sub)",
              border: `1px solid ${canConfirm ? "#ff6b6b" : "rgba(255,107,107,0.30)"}`,
              fontWeight: 700,
            }}
          >{submitting ? "Submitting…" : "Submit Deletion Request"}</button>
        </div>
      </div>
    </div>
  );
}
